import React, { useState, useRef, useEffect } from "react";
import { LoadScriptNext, Autocomplete } from "@react-google-maps/api";
import { useDispatch, useSelector } from "react-redux"; // To connect Redux
import { registerUser, updateUser } from "../../redux/actions/authActions"; // Import the register action
import { toast } from "react-toastify";

import { DashboardLayout } from "../../Pages/dashboard/DashboardLayout";
import { useLocation } from "react-router-dom";
import { FaEdit, FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { FiEye, FiEyeOff, FiMapPin } from "react-icons/fi";
import { FullScreenLoader } from "../../Pages/Components/Loader";

const libraries = ["places"];

const ORDER_TYPE_OPTIONS = [
  { value: "", label: "Select Order Type" },
  { value: "cashback", label: "Cashback" },
  { value: "promotional", label: "Promotional" },
  { value: "loyality", label: "Loyality" },
];

const Register = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [isAddressFetched, setIsAddressFetched] = React.useState(false);
  const [disableCity, setDisableCity] = useState(false);
  const [disableState, setDisableState] = useState(false);
  const [disablePincode, setDisablePincode] = useState(false);
  const [ifscError, setIfscError] = useState("");
  const [accountNumberError, setAccountNumberError] = useState("");
  const [aadharError, setAadharError] = useState("");
  const [gstError, setGstError] = useState("");
  const [panError, setPanError] = useState("");
  const [nameError, setNameError] = useState("");
  const [firmNameError, setFirmNameError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    firm_name: "",
    mobile: "",
    email: "",
    password: "",
    address: "",
    city: "",
    state: "",
    pincode: "",
    lat: "",
    long: "",
    is_auto_approval: false,
    order_type: "",
       kyc_details: {
      aadhar_number: "",
      bank_name: "",
      ifsc_code: "",
      account_number: "",
      account_holder: "",
      gst_number: "",
      pan_number: "",
      remarks: "",
    },
  });

  useEffect(() => {
    if (formData.address && formData.address.trim() !== "") {
      setIsAddressFetched(true);
    }
  }, [formData.address]);
  const handleCollapseToggle = (section) => {
    setCollapse((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  const [mapReady, setMapReady] = useState(false);
  const autocompleteRef = useRef(null);
  const location = useLocation();
  const { userData } = location.state || {};

  // console.log("User ID:", userData.user_id);
  const editUserData = location.state?.userData;
  const [collapse, setCollapse] = useState({
    basic: true,
    bank: false,
    document: false,
  });

  const handlePlaceChanged = () => {
    if (!autocompleteRef.current) return;
    const place = autocompleteRef.current?.getPlace();

    if (place) {
      let address = "";
      let city = "";
      let state = "";
      let pincode = "";
      let lat = "";
      let long = "";

      // Extract the formatted address, city, state, pincode, lat, and long from the place object
      place.address_components.forEach((component) => {
        const types = component.types;
        if (types.includes("locality")) {
          city = component.long_name;
        }
        if (types.includes("administrative_area_level_1")) {
          state = component.long_name;
        }
        if (types.includes("postal_code")) {
          pincode = component.long_name;
        }
      });

      if (place.geometry && place.geometry.location) {
        lat = place.geometry.location.lat();
        long = place.geometry.location.lng();
      }

      address = place.formatted_address;

      // Update the formData state with the extracted values
      setFormData((prev) => ({
        ...prev,
        address,
        city,
        state,
        pincode,
        lat,
        long,
      }));
      setDisableCity(city !== "");
      setDisableState(state !== "");
      setDisablePincode(pincode !== "");
    }
  };
  const dispatch = useDispatch();

  const userInfo = useSelector((state) => state.auth.userInfo); // example for Redux
  const { loading } = useSelector((state) => state.auth || {});

  // const handleChange = (e) => {

  //   const { name, value } = e.target;
  //   if (name === "name") {
  //     // Check if name contains only whitespace
  //     if (value.trim() === "") {
  //       setNameError("Name is required and cannot be only whitespace");
  //     } else {
  //       setNameError("");
  //     }
  //     setFormData((prev) => ({
  //       ...prev,
  //       [name]: value,
  //     }));
  //   }
  //   else if (name === "firm_name") {
  //     // Check if firm_name contains only whitespace
  //     if (value.trim() === "") {
  //       setFirmNameError("Firm Name is required and cannot be only whitespace");
  //     } else {
  //       setFirmNameError("");
  //     }
  //     setFormData((prev) => ({
  //       ...prev,
  //       [name]: value,
  //     }));
  //   }
  //   else if (name === "password") {
  //     // Remove whitespace from password
  //     const cleanedValue = value.replace(/\s/g, "");

  //     // Validate password
  //     if (cleanedValue === "" && !editUserData) {
  //       setPasswordError("Password is required");
  //     } else if (cleanedValue.length > 0 && cleanedValue.length < 6) {
  //       setPasswordError("Password must be at least 6 characters");
  //     } else {
  //       setPasswordError("");
  //     }

  //     setFormData((prev) => ({
  //       ...prev,
  //       [name]: cleanedValue,
  //     }));
  //   }

  //   else if (name === "mobile") {
  //     const cleanedValue = value.replace(/\D/g, "");

  //     // Validate mobile number
  //     if (cleanedValue === "") {
  //       setMobileError("");
  //     } else if (cleanedValue.length < 10) {
  //       setMobileError("Mobile number must be 10 digits");
  //     } else if (!/^[6-9]\d{9}$/.test(cleanedValue)) {
  //       setMobileError("Mobile number must start with 6-9");
  //     } else {
  //       setMobileError("");
  //     }

  //     // Only allow input if less than 10 digits or valid 10 digit number
  //     if (cleanedValue.length <= 10 && (/^[6-9]\d{0,9}$/.test(cleanedValue) || cleanedValue === "")) {
  //       setFormData((prev) => ({
  //         ...prev,
  //         [name]: cleanedValue,
  //       }));
  //     }
  //   }
  //   // else if (name === "mobile") {
  //   //   const cleanedValue = value.replace(/\D/g, "");
  //   //   if (/^[6-9]\d{0,9}$/.test(cleanedValue) || cleanedValue === "") {
  //   //     setFormData((prev) => ({
  //   //       ...prev,
  //   //       [name]: cleanedValue,
  //   //     }));
  //   //   }
  //   //   //  else {
  //   //   //   setFormData((prev) => ({
  //   //   //     ...prev,
  //   //   //     [name]: "",
  //   //   //   }));
  //   //   // }
  //   // }

  //   // Aadhar validation - COMMENTED OUT (KYC fields removed)
  //   // else if (name === "aadhar_number") {
  //   //   const cleanedValue = value.replace(/\D/g, "");
  //   //   if (cleanedValue === "" || /^[2-9]{1}[0-9]{11}$/.test(cleanedValue)) {
  //   //     setAadharError("");
  //   //   } else {
  //   //     setAadharError("Aadhar must be 12 digits and start with 2-9");
  //   //   }
  //   //   setFormData((prev) => ({
  //   //     ...prev,
  //   //     kyc_details: { ...prev.kyc_details, [name]: cleanedValue },
  //   //   }));
  //   // }

  //   // GST validation - COMMENTED OUT (KYC fields removed)
  //   // else if (name === "gst_number") {
  //   //   const upperValue = value.toUpperCase();
  //   //   const gstRegex =
  //   //     /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
  //   //   setGstError(
  //   //     upperValue === "" || gstRegex.test(upperValue)
  //   //       ? ""
  //   //       : "Invalid GST format (e.g. 27AAAPA1234A1Z5)"
  //   //   );
  //   //   setFormData((prev) => ({
  //   //     ...prev,
  //   //     kyc_details: { ...prev.kyc_details, [name]: upperValue },
  //   //   }));
  //   // }

  //   // PAN validation - COMMENTED OUT (KYC fields removed)
  //   // else if (name === "pan_number") {
  //   //   const upperValue = value.toUpperCase();
  //   //   const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
  //   //   setPanError(
  //   //     upperValue === "" || panRegex.test(upperValue)
  //   //       ? ""
  //   //       : "Invalid PAN format (e.g. ABCDE1234F)"
  //   //   );
  //   //   setFormData((prev) => ({
  //   //     ...prev,
  //   //     kyc_details: { ...prev.kyc_details, [name]: upperValue },
  //   //   }));
  //   // }

  //   // IFSC validation - COMMENTED OUT (KYC fields removed)
  //   // else if (name === "ifsc_code") {
  //   //   const upperValue = value.toUpperCase();
  //   //   const isValidIFSC = /^[A-Z]{4}0[A-Z0-9]{6}$/.test(upperValue);
  //   //   setIfscError(upperValue === "" || isValidIFSC ? "" : "Invalid IFSC code");
  //   //   setFormData((prev) => ({
  //   //     ...prev,
  //   //     kyc_details: { ...prev.kyc_details, [name]: upperValue },
  //   //   }));
  //   // }

  //   // Account number validation - COMMENTED OUT (KYC fields removed)
  //   // else if (name === "account_number") {
  //   //   const cleanedValue = value.replace(/\D/g, "");
  //   //   if (
  //   //     cleanedValue.length > 0 &&
  //   //     (cleanedValue.length < 10 || cleanedValue.length > 18)
  //   //   ) {
  //   //     setAccountNumberError(
  //   //       "Account number must be between 10 and 18 digits"
  //   //     );
  //   //   } else {
  //   //     setAccountNumberError("");
  //   //   }
  //   //   setFormData((prev) => ({
  //   //     ...prev,
  //   //     kyc_details: { ...prev.kyc_details, [name]: cleanedValue },
  //   //   }));
  //   // }

  //   // Generic KYC fields - COMMENTED OUT (kyc_details removed)
  //   // else if (name in formData.kyc_details) {
  //   //   setFormData((prev) => ({
  //   //     ...prev,
  //   //     kyc_details: { ...prev.kyc_details, [name]: value },
  //   //   }));
  //   // }

  //   // Non-KYC fields
  //   else {
  //     setFormData((prev) => ({
  //       ...prev,
  //       [name]: value,
  //     }));
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.firm_name || formData.firm_name.trim() === "") {
      setFirmNameError("Firm Name is required and cannot be only whitespace");
      return;
    } else {
      setFirmNameError("");
    }
    if (!formData.name || formData.name.trim() === "") {
      setNameError("Name is required");
      return;
    } else {
      setNameError("");
    }
    if (!formData.mobile || formData.mobile.length < 10) {
      setMobileError("Mobile number must be exactly 10 digits");
      return;
    } else {
      setMobileError("");
    }
    // Password validation
    if (!editUserData && (!formData.password || formData.password.trim() === "")) {
      setPasswordError("Password is required");
      return;
    } else if (formData.password && formData.password.length < 6) {
      setPasswordError("Password must be at least 6 characters");
      return;
    } else {
      setPasswordError("");
    } 
     const ifsc = formData.kyc_details.ifsc_code;
  if (ifsc && ifsc.length > 0) {
    const isValidIFSC = /^[A-Z]{4}0[A-Z0-9]{6}$/.test(ifsc);
    if (!isValidIFSC) {
      setIfscError("Invalid IFSC format (e.g. SBIN0001234)");
      setCollapse((prev) => ({ ...prev, bank: true })); // auto-open section
      return;
    }
  }
    const aadhar = formData.kyc_details.aadhar_number;
  if (aadhar && aadhar.length > 0) {
    const digits = aadhar.replace(/\s/g, "");
    if (digits.length !== 12) {
      setAadharError(`${12 - digits.length} more digit${12 - digits.length !== 1 ? "s" : ""} needed`);
      setCollapse((prev) => ({ ...prev, document: true })); // auto-open section
      return;
    }
  }
   const gst = formData.kyc_details.gst_number;
  if (gst && gst.length > 0) {
    const gstCleaned = gst.replace(/\s/g, "");
    const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
    if (!gstRegex.test(gstCleaned)) {
      setGstError("Invalid GST format (e.g. 27AAAPA1234A1Z5)");
      setCollapse((prev) => ({ ...prev, document: true }));
      return;
    }
  }

  const pan = formData.kyc_details.pan_number;
  if (pan && pan.length > 0) {
    const panCleaned = pan.replace(/\s/g, "");
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
    if (!panRegex.test(panCleaned)) {
      setPanError("Invalid PAN format (e.g. ABCDE1234F)");
      setCollapse((prev) => ({ ...prev, document: true }));
      return;
    }
  }
    if (ifscError || accountNumberError || aadharError || gstError || panError) {
    if (ifscError || accountNumberError) {
      setCollapse((prev) => ({ ...prev, bank: true }));
    }
    if (aadharError || gstError || panError) {
      setCollapse((prev) => ({ ...prev, document: true }));
    }
    return;
  }

    const token = userInfo?.access_token;

    if (!token) {
      console.error("Token is missing during submit!");
      return;
    }

    if (editUserData) {
      const updatedFormData = {
        ...formData,
      };

      const result = await dispatch(
        updateUser(updatedFormData, token, userData.user_id)
      );
      if (result?.success) {
        navigate("/dashboard/UserList");
      }
    } else {
      const result = await dispatch(registerUser(formData, token));

      if (result?.success) {
        navigate("/dashboard/UserList");
      }
    }
  };
 
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "mobile") {
      const cleaned = value.replace(/\D/g, "");

      // Only allow digits starting with 6-9, max 10
      if (/^[6-9]\d{0,9}$/.test(cleaned) || cleaned === "") {
        setFormData((prev) => ({ ...prev, [name]: cleaned }));
      }

      // Live validation message
      if (cleaned === "") {
        setMobileError("");
      } else if (!/^[6-9]/.test(cleaned)) {
        setMobileError("Mobile number must start with 6, 7, 8 or 9");
      } else if (cleaned.length < 10) {
        setMobileError(`${10 - cleaned.length} more digit${10 - cleaned.length !== 1 ? "s" : ""} needed`);
      } else {
        setMobileError("");
      }
    }
    else if (name === "firm_name") {
      const cleaned = value
        .replace(/[^a-zA-Z\s]/g, "")    // remove numbers & special characters
        .replace(/^\s+/, "")             // no leading whitespace
        .replace(/\s{2,}/g, " ");        // no double spaces

      setFirmNameError(
        cleaned.trim() === "" && value !== ""
          ? "Firm Name cannot be only whitespace"
          : ""
      );
      setFormData((prev) => ({ ...prev, [name]: cleaned }));
    }

    else if (name === "name") {
      const cleaned = value
        .replace(/[^a-zA-Z\s]/g, "")    // remove numbers & special characters
        .replace(/^\s+/, "")             // no leading whitespace
        .replace(/\s{2,}/g, " ");        // no double spaces

      setNameError(
        cleaned.trim() === "" && value !== ""
          ? "Name cannot be only whitespace"
          : ""
      );
      setFormData((prev) => ({ ...prev, [name]: cleaned }));
    }
    else if (name === "password") {
      const cleaned = value.replace(/\s/g, ""); // strip all whitespace

      if (cleaned.length > 0 && cleaned.length < 6) {
        setPasswordError("Password must be at least 6 characters");
      } else {
        setPasswordError("");
      }

      setFormData((prev) => ({ ...prev, [name]: cleaned }));
    }
    // Aadhar validation
    else if (name === "aadhar_number") {
      const cleanedValue = value.replace(/\D/g, "");
      if (cleanedValue === "" || /^[2-9]{1}[0-9]{11}$/.test(cleanedValue)) {
        setAadharError("");
      } else {
        setAadharError("Aadhar must be 12 digits and start with 2-9");
      }
      setFormData((prev) => ({
        ...prev,
        kyc_details: { ...prev.kyc_details, [name]: cleanedValue },
      }));
    }

    // GST validation
    else if (name === "gst_number") {
      const upperValue = value.toUpperCase();
      const gstRegex =
        /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
      setGstError(
        upperValue === "" || gstRegex.test(upperValue)
          ? ""
          : "Invalid GST format (e.g. 27AAAPA1234A1Z5)"
      );
      setFormData((prev) => ({
        ...prev,
        kyc_details: { ...prev.kyc_details, [name]: upperValue },
      }));
    }

    // PAN validation
    else if (name === "pan_number") {
      const upperValue = value.toUpperCase();
      const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
      setPanError(
        upperValue === "" || panRegex.test(upperValue)
          ? ""
          : "Invalid PAN format (e.g. ABCDE1234F)"
      );
      setFormData((prev) => ({
        ...prev,
        kyc_details: { ...prev.kyc_details, [name]: upperValue },
      }));
    }

    // IFSC validation
 else if (name === "ifsc_code") {
  const cleaned = value.replace(/[^a-zA-Z0-9]/g, "").toUpperCase().slice(0, 11);
  const isValidIFSC = /^[A-Z]{4}0[A-Z0-9]{6}$/.test(cleaned);
  setIfscError(
    cleaned === "" || isValidIFSC
      ? ""
      : cleaned.length < 11
      ? `${11 - cleaned.length} more character${11 - cleaned.length !== 1 ? "s" : ""} needed`
      : "Invalid IFSC format (e.g. SBIN0001234)"  // ← this line
  );
  setFormData((prev) => ({
    ...prev,
    kyc_details: { ...prev.kyc_details, [name]: cleaned },
  }));
}

    // Account number validation
    else if (name === "account_number") {
      const cleanedValue = value.replace(/\D/g, "");
      if (
        cleanedValue.length > 0 &&
        (cleanedValue.length < 10 || cleanedValue.length > 18)
      ) {
        setAccountNumberError(
          "Account number must be between 10 and 18 digits"
        );
      } else {
        setAccountNumberError("");
      }
      setFormData((prev) => ({
        ...prev,
        kyc_details: { ...prev.kyc_details, [name]: cleanedValue },
      }));
    }

    // Generic KYC fields
    else if (name in formData.kyc_details) {
      setFormData((prev) => ({
        ...prev,
        kyc_details: { ...prev.kyc_details, [name]: value },
      }));
    }

    // Non-KYC fields
    else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };
  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   const token = userInfo?.access_token;
  //   if (!formData.name || formData.name.trim() === "") {
  //     setNameError("Name is required and cannot be only whitespace");
  //     return;
  //   }
  //   if (!formData.firm_name || formData.firm_name.trim() === "") {
  //     setFirmNameError("Firm Name is required and cannot be only whitespace");
  //     return;
  //   }
  //   // Validate password length if provided
  //   if (formData.password && formData.password.length < 6) {
  //     setPasswordError("Password must be at least 6 characters");
  //     return;
  //   }
  //   // Validate mobile
  //   if (!formData.mobile || formData.mobile.length !== 10) {
  //     setMobileError("Mobile number must be exactly 10 digits");
  //     return;
  //   }

  //   if (!token) {
  //     console.error("Token is missing during submit!");
  //     return;
  //   }

  //   if (editUserData) {
  //     // Compare edited form data with original data
  //     const hasChanges =
  //       JSON.stringify(formData) !== JSON.stringify(editUserData);

  //     if (!hasChanges) {
  //       toast.info("No changes detected.");
  //       navigate("/dashboard/UserList");
  //       return;
  //     }

  //     // Prepare form data for update - exclude kyc_details and only send fields that API accepts
  //     const updatedFormData = {
  //       name: formData.name,
  //       firm_name: formData.firm_name,
  //       mobile: formData.mobile,
  //       email: formData.email,
  //       address: formData.address,
  //       city: formData.city,
  //       state: formData.state,
  //       pincode: formData.pincode,
  //       lat: formData.lat,
  //       long: formData.long,
  //     is_auto_approval: Boolean(formData.is_auto_approval),
  //       order_type: formData.order_type,
  //     };

  //     // Only include password if it's been changed (not empty)
  //     if (formData.password && formData.password.trim() !== "") {
  //       updatedFormData.password = formData.password;
  //     }

  //     const result = await dispatch(
  //       updateUser(updatedFormData, token, userData.user_id)
  //     );

  //     if (result?.success) {
  //       navigate("/dashboard/UserList");
  //     }
  //   } else {
  //     const result = await dispatch(registerUser(formData, token));

  //     if (result?.success) {
  //       navigate("/dashboard/UserList");
  //     }
  //   }
  // };

  useEffect(() => {
    if (editUserData) {

          const autoApprovalValue = 
      editUserData.is_auto_approval === true || 
      editUserData.is_auto_approval === 1 || 
      editUserData.is_auto_approval === "true" ||
      editUserData.is_auto_approval === "1"
      ? true 
      : false;

      setFormData((prev) => ({
        ...prev,
        name: editUserData.name || "",
        firm_name: editUserData.firm_name || "",
        mobile: editUserData.mobile || "",
        email: editUserData.email || "",
        password: "",
        address: editUserData.address || "",
        city: editUserData.city || "",
        state: editUserData.state || "",
        pincode: editUserData.pincode || "",
        lat: editUserData.lat || "",
        long: editUserData.long || "",
       is_auto_approval: autoApprovalValue,
       order_type: editUserData.order_type || "",
        // kyc_details: {
        //   ...prev.kyc_details,
        //   ...editUserData.kyc_details,
        // },
      }));
    }
  }, [editUserData]);

  return (
    <DashboardLayout>
      <FullScreenLoader
        show={loading}
        message={loading ? (userData ? "Updating user..." : "Creating user...") : ""}
        variant="primary"
        blurIntensity="md"
      />
      <LoadScriptNext
        googleMapsApiKey="AIzaSyBjwQjSQoYFe5OzJxbhnodl-usXAt6AH8g"
        libraries={libraries}
        onLoad={() => setMapReady(true)}
      >
        {mapReady ? (
          <div className="w-full max-w-7xl mx-auto pt-4 px-4">
            <form
              onSubmit={handleSubmit}
              className="rounded-xl w-full"
            >
              <div className="flex items-center gap-3 mb-6">
                <button
                  onClick={() => navigate(-1)}
                  className="hover:text-gray-800 transition-colors p-2 hover:bg-amber-50 rounded-lg"
                >
                  <FaArrowLeft size={20} />
                </button>
                <h2 className="text-3xl font-bold bg-gradient-to-r from-amber-600 to-amber-500 bg-clip-text text-transparent">
                  {editUserData ? "Edit Account" : "Create Account"}
                </h2>
              </div>

              {/* Basic Details Section */}
              <div className="bg-white mb-6 border-2 border-amber-500 rounded-xl shadow-lg overflow-hidden transition-all duration-300 hover:shadow-xl">
                <button
                  type="button"
                  onClick={() => handleCollapseToggle("basic")}
                  className="w-full text-left px-6 py-4 bg-gradient-to-r from-amber-400 to-amber-500 hover:from-amber-500 hover:to-amber-600 text-white font-semibold flex justify-between items-center transition-all duration-200"
                >
                  <h2 className="text-lg font-bold flex items-center gap-2">
                    <span className="text-xl">📋</span>
                    Basic Details
                  </h2>
                  <span className="text-xl transition-transform duration-200">{collapse.basic ? "▲" : "▼"}</span>
                </button>
                {collapse.basic && (
                  <div className="p-6 bg-gradient-to-br from-white to-amber-50/30">
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                      {/* Firm Name */}
                      <div className="relative group">
                        <input
                          type="text"
                          name="firm_name"
                          value={formData.firm_name}
                          onChange={handleChange}
                          className={`peer w-full border rounded-lg px-2 pt-3 pb-1 text-sm focus:outline-none transition-all duration-200 bg-white shadow-sm hover:border-amber-400 ${firmNameError
                              ? "border-red-500 focus:border-red-500 focus:ring-2 focus:ring-red-200"
                              : "border-gray-300 focus:border-amber-500 focus:ring-2 focus:ring-amber-200"
                            }`}
                          placeholder=" "
                          required
                        />
                        <label
                          htmlFor="firm_name"
                          className={`pointer-events-none absolute left-2 -top-2 text-xs bg-white px-1 transition-all duration-200 font-medium
    peer-placeholder-shown:top-2 peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-400
    peer-focus:-top-2 peer-focus:text-xs peer-focus:font-semibold ${firmNameError
                              ? "text-red-600 peer-focus:text-red-600"
                              : "text-gray-600 peer-focus:text-amber-600"
                            }`}
                        >
                          Firm Name <span className="text-red-500">*</span>
                        </label>
                        {firmNameError && (
                          <p className="text-xs text-red-500 mt-1 ml-1 font-medium"> {firmNameError}</p>
                        )}
                      </div>
                      {/* Name */}
                      <div className="relative group">
                        <input
                          type="text"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                        className={`peer w-full border rounded-lg px-2 pt-3 pb-1 text-sm focus:outline-none transition-all duration-200 bg-white shadow-sm hover:border-amber-400 ${firmNameError
                              ? "border-red-500 focus:border-red-500 focus:ring-2 focus:ring-red-200"
                              : "border-gray-300 focus:border-amber-500 focus:ring-2 focus:ring-amber-200"
                            }`}
                          placeholder=" "
                          required
                        />
                        <label
                          htmlFor="name"
                           className={`pointer-events-none absolute left-2 -top-2 text-xs bg-white px-1 transition-all duration-200 font-medium
    peer-placeholder-shown:top-2 peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-400
    peer-focus:-top-2 peer-focus:text-xs peer-focus:font-semibold ${nameError
                              ? "text-red-600 peer-focus:text-red-600"
                              : "text-gray-600 peer-focus:text-amber-600"
                            }`}
                        >
                          Name <span className="text-red-500">*</span>
                        </label>
                        {nameError && (
                          <p className="text-xs text-red-500 mt-1 ml-1 font-medium"> {nameError}</p>
                        )}
                      </div>

                      {/* Mobile */}
                      <div className="relative group">
                        <input
                          type="text"
                          name="mobile"
                          value={formData.mobile}
                          onChange={handleChange}
                          maxLength="10"
                         className={`peer w-full border rounded-lg px-2 pt-3 pb-1 text-sm focus:outline-none transition-all duration-200 bg-white shadow-sm hover:border-amber-400 ${firmNameError
                              ? "border-red-500 focus:border-red-500 focus:ring-2 focus:ring-red-200"
                              : "border-gray-300 focus:border-amber-500 focus:ring-2 focus:ring-amber-200"
                            }`}
                          placeholder=" "
                          required
                        />
                        <label
                          htmlFor="mobile"
                           className={`pointer-events-none absolute left-2 -top-2 text-xs bg-white px-1 transition-all duration-200 font-medium
    peer-placeholder-shown:top-2 peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-400
    peer-focus:-top-2 peer-focus:text-xs peer-focus:font-semibold ${mobileError
                              ? "text-red-600 peer-focus:text-red-600"
                              : "text-gray-600 peer-focus:text-amber-600"
                            }`}
                        >
                          Mobile <span className="text-red-500">*</span>
                        </label>
                        {mobileError && (
                          <p className="text-xs text-red-500 mt-1 ml-1 font-medium"> {mobileError}</p>
                        )}
                        {formData.mobile && formData.mobile.length === 10 && !mobileError && (
                          <p className="text-xs text-green-600 mt-1 ml-1 font-medium">Valid mobile number</p>
                        )}
                      </div>

                      {/* Email */}
                      <div className="relative group">
                        <input
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                        className={`peer w-full border rounded-lg px-2 pt-3 pb-1 text-sm focus:outline-none transition-all duration-200 bg-white shadow-sm hover:border-amber-400 ${firmNameError
                              ? "border-red-500 focus:border-red-500 focus:ring-2 focus:ring-red-200"
                              : "border-gray-300 focus:border-amber-500 focus:ring-2 focus:ring-amber-200"
                            }`}
                          placeholder=" "
                        />
                        <label
                          htmlFor="email"
                          className={`pointer-events-none absolute left-2 -top-2 text-xs bg-white px-1 transition-all duration-200 font-medium
    peer-placeholder-shown:top-2 peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-400
    peer-focus:-top-2 peer-focus:text-xs peer-focus:font-semibold`}
                        >
                          Email
                        </label>
                      </div>

                      <div className="relative group">
                        <input
                          type={showPassword ? "text" : "password"}
                          name="password"
                          value={formData.password}
                          onChange={handleChange}
                        className={`peer w-full border rounded-lg px-2 pt-3 pb-1 text-sm focus:outline-none transition-all duration-200 bg-white shadow-sm hover:border-amber-400 ${firmNameError
                              ? "border-red-500 focus:border-red-500 focus:ring-2 focus:ring-red-200"
                              : "border-gray-300 focus:border-amber-500 focus:ring-2 focus:ring-amber-200"
                            }`}
                          placeholder=" "
                          required={!editUserData}
                        />
                        <label
                          htmlFor="password"
                           className={`pointer-events-none absolute left-2 -top-2 text-xs bg-white px-1 transition-all duration-200 font-medium
    peer-placeholder-shown:top-2 peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-400
    peer-focus:-top-2 peer-focus:text-xs peer-focus:font-semibold ${passwordError
                              ? "text-red-600 peer-focus:text-red-600"
                              : "text-gray-600 peer-focus:text-amber-600"
                            }`}
                        >
                          Password {!editUserData && <span className="text-red-500">*</span>}
                        </label>

                        <div
                          className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer text-amber-600 hover:text-amber-700 transition-colors"
                          onClick={() => setShowPassword((prev) => !prev)}
                        >
                          {showPassword ? <FiEyeOff size={20} /> : <FiEye size={20} />}
                        </div>

                        {passwordError && (
                          <p className="text-xs text-red-500 mt-1 ml-1 font-medium">{passwordError}</p>
                        )}

                        {editUserData && (
                          <p className="text-xs text-amber-600 mt-2 ml-1 font-medium">
                            Leave blank to keep current password
                          </p>
                        )}
                      </div>

                        <div className="relative group">
                        <select
                          name="order_type"
                          id="order_type"
                          value={formData.order_type}
                          onChange={handleChange}
                          className="peer w-full border rounded-lg px-2 pt-3 pb-1 text-sm focus:outline-none transition-all duration-200 bg-white shadow-sm hover:border-amber-400 border-gray-300 focus:border-amber-500 focus:ring-2 focus:ring-amber-200 appearance-none cursor-pointer"
                        >
                          {ORDER_TYPE_OPTIONS.map((opt) => (
                            <option key={opt.value} value={opt.value} disabled={opt.value === ""}>
                              {opt.label}
                            </option>
                          ))}
                        </select>
                        <label
                          htmlFor="order_type"
                          className="pointer-events-none absolute left-2 -top-2 text-xs bg-white px-1 font-medium text-gray-600"
                        >
                          Order Type<span className="text-red-500">*</span>
                        </label>
                        {/* Custom chevron arrow */}
                        <div className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-amber-600">
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                          </svg>
                        </div>
                      </div>

                      {/* Address Autocomplete */}
                      <div className="relative group sm:col-span-2 lg:col-span-3">
                        <Autocomplete
                          onLoad={(ref) => (autocompleteRef.current = ref)}
                          onPlaceChanged={() => {
                            handlePlaceChanged();
                            setIsAddressFetched(true); // Mark as fetched
                          }}
                        >
                          <input
                            type="text"
                            name="address"
                            value={formData.address}
                            onChange={(e) => {
                              handleChange(e);
                              setIsAddressFetched(false); // User typing manually, enable city/state/pincode inputs
                            }}
                            placeholder="Start typing address..."
                           className={`peer w-full border rounded-lg px-2 pt-3 pb-1 text-sm focus:outline-none transition-all duration-200 bg-white shadow-sm hover:border-amber-400 ${firmNameError
                              ? "border-red-500 focus:border-red-500 focus:ring-2 focus:ring-red-200"
                              : "border-gray-300 focus:border-amber-500 focus:ring-2 focus:ring-amber-200"
                            }`}
                         />
                        </Autocomplete>
                        {!isAddressFetched && (
                          <div className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none">
                            <FiMapPin className="w-5 h-5 text-amber-600" />
                          </div>
                        )}
                        <label
                          htmlFor="address"
                      className={`pointer-events-none absolute left-2 -top-2 text-xs bg-white px-1 transition-all duration-200 font-medium
    peer-placeholder-shown:top-2 peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-400
    peer-focus:-top-2 peer-focus:text-xs peer-focus:font-semibold`}
                      >
                          Address
                        </label>
                      </div>

                      <div className="relative group">
                        <input
                          type="text"
                          name="city"
                          value={formData.city}
                          onChange={handleChange}
                          disabled={disableCity}
                          placeholder=""
                       className={`peer w-full border rounded-lg px-2 pt-3 pb-1 text-sm focus:outline-none transition-all duration-200 bg-white shadow-sm hover:border-amber-400 ${firmNameError
                              ? "border-red-500 focus:border-red-500 focus:ring-2 focus:ring-red-200"
                              : "border-gray-300 focus:border-amber-500 focus:ring-2 focus:ring-amber-200"
                            }`}
                      />

                        <label
                          htmlFor="city"
                        className={`pointer-events-none absolute left-2 -top-2 text-xs bg-white px-1 transition-all duration-200 font-medium
    peer-placeholder-shown:top-2 peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-400
    peer-focus:-top-2 peer-focus:text-xs peer-focus:font-semibold`}
                        >
                          City
                        </label>
                      </div>
                      <div className="relative group">
                        <input
                          type="text"
                          name="state"
                          value={formData.state}
                          onChange={handleChange}
                          disabled={disableState}
                          placeholder=""
                         className={`peer w-full border rounded-lg px-2 pt-3 pb-1 text-sm focus:outline-none transition-all duration-200 bg-white shadow-sm hover:border-amber-400 ${firmNameError
                              ? "border-red-500 focus:border-red-500 focus:ring-2 focus:ring-red-200"
                              : "border-gray-300 focus:border-amber-500 focus:ring-2 focus:ring-amber-200"
                            }`}
                      />

                        <label
                          htmlFor="state"
                      className={`pointer-events-none absolute left-2 -top-2 text-xs bg-white px-1 transition-all duration-200 font-medium
    peer-placeholder-shown:top-2 peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-400
    peer-focus:-top-2 peer-focus:text-xs peer-focus:font-semibold`}
                      >
                          State
                        </label>
                      </div>
                      <div className="relative group">
                        <input
                          type="text"
                          name="pincode"
                          value={formData.pincode}
                          onChange={handleChange}
                          disabled={disablePincode}
                          placeholder=""
                         className={`peer w-full border rounded-lg px-2 pt-3 pb-1 text-sm focus:outline-none transition-all duration-200 bg-white shadow-sm hover:border-amber-400 ${firmNameError
                              ? "border-red-500 focus:border-red-500 focus:ring-2 focus:ring-red-200"
                              : "border-gray-300 focus:border-amber-500 focus:ring-2 focus:ring-amber-200"
                            }`}
                       />

                        <label
                          htmlFor="pincode"
                      className={`pointer-events-none absolute left-2 -top-2 text-xs bg-white px-1 transition-all duration-200 font-medium
    peer-placeholder-shown:top-2 peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-400
    peer-focus:-top-2 peer-focus:text-xs peer-focus:font-semibold`}
                      >
                          Pincode
                        </label>
                      </div>
                      {/* Hidden fields */}
                      {/* <input name="city" value={formData.city} />
                    <input name="state" value={formData.state} />
                    <input
                      type="hidden"
                      name="pincode"
                      value={formData.pincode}
                    /> */}
                      <input type="hidden" name="lat" value={formData.lat} />
                      <input type="hidden" name="long" value={formData.long} />

                      {/* Is Auto Approval Field */}
                      <div className="py-4 relative flex items-center space-x-3 bg-amber-50 border-2 border-amber-200 rounded-lg px-4 py-4 shadow-sm">
                        <input
                          type="checkbox"
                          name="is_auto_approval"
                          id="is_auto_approval"
                          checked={formData.is_auto_approval === true}
                          onChange={(e) => setFormData((prev) => ({ ...prev, is_auto_approval: e.target.checked }))}
                         className={`
                          `} 
                       />
                        <label
                          htmlFor="is_auto_approval"
                          className="text-sm font-semibold text-gray-700 cursor-pointer flex items-center gap-2"
                        >
                          
                          <span>Is Auto Approval</span>
                        </label>
                      </div>
                    </div>
                  </div>
                )}
              </div>
                {/* Bank Details Section */}
              <div className="mb-6 bg-white mb-6 border border-amber-500 rounded-md shadow-sm">
                <button
                  type="button"
                  onClick={() => handleCollapseToggle("bank")}
                  className="w-full text-left px-4 py-3 bg-amber-300  hover:bg-amber-400 text-gray-950 font-semibold flex justify-between items-center"
                >
                  <h2 className="text-md font-semibold text-gray-950">
                    Bank Details
                  </h2>
                  <span>{collapse.bank ? "▲" : "▼"}</span>
                </button>
                {collapse.bank && (
                  <div className="p-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                    {/* Bank Name */}
                    <div className="relative">
                      <input
                        type="text"
                        name="bank_name"
                        value={formData.kyc_details.bank_name}
                        onChange={handleChange}
                        className="peer w-full border border-gray-300 rounded-md px-3 pt-5 pb-2 text-sm focus:outline-none focus:border-blue-500"
                        placeholder=" "
                      />
                      <label
                        htmlFor="bank_name"
                        className="pointer-events-none absolute left-2.5 -top-2 text-xs bg-white px-1 transition-all duration-200 text-gray-500
                        peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-400
                        peer-focus:-top-2 peer-focus:text-xs peer-focus:text-blue-500"
                      >
                        Bank Name
                      </label>
                    </div>

                    {/* IFSC Code */}
                    <div className="relative">
                      <input
                        type="text"
                        name="ifsc_code"
                        value={formData.kyc_details.ifsc_code}
                        onChange={handleChange}
                        className="peer w-full border border-gray-300 rounded-md px-3 pt-5 pb-2 text-sm focus:outline-none focus:border-blue-500"
                        placeholder=" "
                      />
                      {ifscError && (
                        <p className="text-red-500 text-xs mt-1">{ifscError}</p>
                      )}

                      <label
                        htmlFor="ifsc_code"
                        className="pointer-events-none absolute left-2.5 -top-2 text-xs bg-white px-1 transition-all duration-200 text-gray-500
                        peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-400
                        peer-focus:-top-2 peer-focus:text-xs peer-focus:text-blue-500"
                      >
                        IFSC Code
                      </label>
                    </div>

                    {/* Account Number */}
                    <div className="relative">
                      <input
                        type="text"
                        name="account_number"
                        value={formData.kyc_details.account_number}
                        onChange={handleChange}
                        className="peer w-full border border-gray-300 rounded-md px-3 pt-5 pb-2 text-sm focus:outline-none focus:border-blue-500"
                        placeholder=" "
                      />
                      {accountNumberError && (
                        <p className="text-red-500 text-xs mt-1">
                          {accountNumberError}
                        </p>
                      )}

                      <label
                        htmlFor="account_number"
                        className="pointer-events-none absolute left-2.5 -top-2 text-xs bg-white px-1 transition-all duration-200 text-gray-500
                        peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-400
                        peer-focus:-top-2 peer-focus:text-xs peer-focus:text-blue-500"
                      >
                        Account Number
                      </label>
                    </div>

                    {/* Account Holder Name */}
                    <div className="relative">
                      <input
                        type="text"
                        name="account_holder"
                        value={formData.kyc_details.account_holder}
                        onChange={handleChange}
                        className="peer w-full border border-gray-300 rounded-md px-3 pt-5 pb-2 text-sm focus:outline-none focus:border-blue-500"
                        placeholder=" "
                      />
                      <label
                        htmlFor="account_holder"
                        className="pointer-events-none absolute left-2.5 -top-2 text-xs bg-white px-1 transition-all duration-200 text-gray-500
                        peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-400
                        peer-focus:-top-2 peer-focus:text-xs peer-focus:text-blue-500"
                      >
                        Account Holder Name
                      </label>
                    </div>
                  </div>
                )}
              </div>

              {/* Document Details Section */}
              <div className="mb-6 bg-white border  border-amber-500  rounded-md shadow-sm">
                <button
                  type="button"
                  onClick={() => handleCollapseToggle("document")}
                  className="w-full text-left px-4 py-3 bg-amber-300  hover:bg-amber-400 text-gray-950 font-semibold flex justify-between items-center"
                >
                  <h2 className="text-md font-semibold text-gray-950">
                    Document Details
                  </h2>
                  <span>{collapse.document ? "▲" : "▼"}</span>
                </button>
                {collapse.document && (
                  <div className="p-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                    {/* Aadhar Number */}
                    <div className="relative">
                      <input
                        type="text"
                        name="aadhar_number"
                        value={formData.kyc_details.aadhar_number}
                        onChange={handleChange}
                        className="peer w-full border border-gray-300 rounded-md px-3 pt-5 pb-2 text-sm focus:outline-none focus:border-blue-500"
                        placeholder=" "
                      />
                      {aadharError && (
                        <p className="text-red-500 text-xs mt-1">
                          {aadharError}
                        </p>
                      )}

                      <label
                        htmlFor="aadhar_number"
                        className="pointer-events-none absolute left-2.5 -top-2 text-xs bg-white px-1 transition-all duration-200 text-gray-500
                        peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-400
                        peer-focus:-top-2 peer-focus:text-xs peer-focus:text-blue-500"
                      >
                        Aadhar Number
                      </label>
                    </div>

                    {/* GST Number */}
                    <div className="relative">
                      <input
                        type="text"
                        name="gst_number"
                        value={formData.kyc_details.gst_number}
                        onChange={handleChange}
                        className="peer w-full border border-gray-300 rounded-md px-3 pt-5 pb-2 text-sm focus:outline-none focus:border-blue-500"
                        placeholder=" "
                      />
                      {gstError && (
                        <p className="text-red-500 text-xs mt-1">{gstError}</p>
                      )}
                      <label
                        htmlFor="gst_number"
                        className="pointer-events-none absolute left-2.5 -top-2 text-xs bg-white px-1 transition-all duration-200 text-gray-500
                        peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-400
                        peer-focus:-top-2 peer-focus:text-xs peer-focus:text-blue-500"
                      >
                        GST Number
                      </label>
                    </div>

                    {/* PAN Number */}
                    <div className="relative">
                      <input
                        type="text"
                        name="pan_number"
                        value={formData.kyc_details.pan_number}
                        onChange={handleChange}
                        className="peer w-full border border-gray-300 rounded-md px-3 pt-5 pb-2 text-sm focus:outline-none focus:border-blue-500"
                        placeholder=" "
                      />
                      {panError && (
                        <p className="text-red-500 text-xs mt-1">{panError}</p>
                      )}
                      <label
                        htmlFor="pan_number"
                        className="pointer-events-none absolute left-2.5 -top-2 text-xs bg-white px-1 transition-all duration-200 text-gray-500
                        peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-400
                        peer-focus:-top-2 peer-focus:text-xs peer-focus:text-blue-500"
                      >
                        PAN Number
                      </label>
                    </div>
                    <div className="relative mb-6">
                      <input
                        type="text"
                        name="remarks"
                        value={formData.kyc_details.remarks}
                        onChange={handleChange}
                        className="peer w-full border border-gray-300 rounded-md px-3 pt-5 pb-2 text-sm focus:outline-none focus:border-blue-500"
                        placeholder=" "
                      />

                      <label
                        htmlFor="remarks"
                        className="pointer-events-none absolute left-2.5 -top-2 text-xs bg-white px-1 transition-all duration-200 text-gray-500 peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-400 peer-focus:-top-2 peer-focus:text-xs peer-focus:text-blue-500"
                      >
                        Remarks
                      </label>
                    </div>
                  </div>
                )}
              </div>

              {/* Action Buttons */}
              <div className="flex justify-end gap-4 mt-8 mb-6">
                <button
                  type="button"
                  onClick={() => navigate(-1)}
                  className="bg-white border-2 border-red-500 text-red-600 py-2 px-4 text-md rounded-lg hover:bg-red-50 font-semibold transition-all duration-200 shadow-sm hover:shadow-md"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="bg-amber-600 text-white py-2 px-4 text-md rounded-lg hover:from-amber-600 hover:to-amber-700 font-semibold transition-all duration-200 shadow-md hover:shadow-lg transform hover:scale-105"
                >
                  {editUserData ? "Update Account" : "Create Account"}
                </button>
              </div>
            </form>
          </div>
        ) : (
          <div className="flex justify-center items-center min-h-screen">
            <p className="text-gray-500 text-lg">Loading Google Maps...</p>
          </div>
        )}
      </LoadScriptNext>
    </DashboardLayout>
  );
};

export default Register;
